// extracted by mini-css-extract-plugin
module.exports = {"row":"SociometryResultDetailsQuestions_row__mrH3z","rowHeader":"SociometryResultDetailsQuestions_rowHeader__2dC8T","center":"SociometryResultDetailsQuestions_center__3l6qM"};